import React from 'react';
import type { TrashedPlans } from '@atlassian/jira-spa-apps-trashed-plans/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyTrashedPlans = lazyForPaint<typeof TrashedPlans>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-trashed-plans", jiraSpaEntry: "async-trashed-plans" */ '@atlassian/jira-spa-apps-trashed-plans'
		).then((module) => module.TrashedPlans),
	),
);

export const TrashedPlansDirectory = () => (
	<LazyPage Page={LazyTrashedPlans} pageId="trashed-plans" shouldShowSpinner />
);
